<template>
  <div class="loader" :style="'height: calc('+height+'vh - 120px);'">
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 100 100" xml:space="preserve">
      <rect x="60" y="40" width="4" height="10" fill="#2BB637">
        <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0" dur="0.6s" repeatCount="indefinite" />
      </rect>
      <rect x="50" y="40" width="4" height="10" fill="#2BB637">
        <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0.2s" dur="0.6s" repeatCount="indefinite" />
      </rect>
      <rect x="40" y="40" width="4" height="10" fill="#2BB637">
        <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0.4s" dur="0.6s" repeatCount="indefinite" />
      </rect>
    </svg>
    <div class="text-gray-500 fs-8">{{ text }}</div>
  </div>
</template>
<script>
  export default {
    name: 'Loader',
    props: {
      height: {
        type: Number,
        default: 30
      },
      text: {
        type: String,
        default: 'Загрузка'
      }
    }
  }
</script>

<style scoped>
.loader {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>